define('customPlugins/atnAreObservablesValid',[
        'knockout', 'lodash', 'jquery', 'kendo-knockout'
    ],
    function(ko, _, $) {
        'use strict';

        ko.bindingHandlers.atnAreObservablesValid = {
            update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
                var options = valueAccessor();
                var arrayOfObservables = options.list;
                var isValidObs = options.areValid;
                var showAllMessages = function() {
                    var showMessages;
                    if (bindingContext.$data.showAllMessages) {
                        showMessages = bindingContext.$data.showAllMessages();
                    } else {
                        showMessages = bindingContext.$parent.showAllMessages();
                    }
                    return showMessages;
                }();
                var returnValue = true;

                // here we will check if isValid method is attached to the observable
                // if yes then return obs.isValid
                // else return true (this will be applicable for the first time observable is initialized)
                returnValue = _.reduce(arrayOfObservables, function(returnVal, singleObservable) {
                    var observableValue = singleObservable();
                    if (singleObservable && singleObservable.isValid) {
                        returnVal = returnVal && singleObservable.isValid();
                    }
                    return returnVal;
                }, true);

                // if observable is NotValid then attach css class 'atn-icon-errors'(for error icon) else remove the class
                if (!returnValue && showAllMessages) {
                    isValidObs(false);
                } else {
                    isValidObs(true);
                }
            }
        };
    });
